import { render, staticRenderFns } from "./HeaderDropDown.vue?vue&type=template&id=bca06ff8&scoped=true"
import script from "./HeaderDropDown.vue?vue&type=script&lang=js"
export * from "./HeaderDropDown.vue?vue&type=script&lang=js"
import style0 from "./HeaderDropDown.vue?vue&type=style&index=0&id=bca06ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca06ff8",
  null
  
)

export default component.exports